// Smooth cine rate (~5–6 fps).
export const CINE_INTERVAL_MS = 180;

/**
 * Ping-pong index: maps a monotonically increasing tick to a frame index that
 * sweeps forward then back through [0, length-1] and loops —
 * 0,1,…,L-1,L-2,…,1,0,1,… (period 2*(L-1)). length<=1 → always 0.
 *
 * Pure + exported so it can be unit-tested and so each tile can index its own
 * frame count (windows differ in length near series edges).
 */
export function pingPongIndex(tick: number, length: number): number {
  if (length <= 1) return 0;
  const period = 2 * (length - 1);
  const r = ((tick % period) + period) % period; // guard negative ticks
  return r < length ? r : period - r;
}
